import { render, staticRenderFns } from "./PhysiotherapistDetail.vue?vue&type=template&id=a710d156"
import script from "./PhysiotherapistDetail.vue?vue&type=script&lang=ts"
export * from "./PhysiotherapistDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports